import React from 'react';

import { useIntl } from 'react-intl-next';

import Button from '@atlaskit/button';
import ErrorIcon from '@atlaskit/icon/core/migration/error';
import { N500 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import { StyledBox, StyledText } from '../../../styled';

import messages from './messages';
import { type ErrorMessageProps } from './types';

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ onRetry }) => {
	const { formatMessage } = useIntl();

	return (
		<StyledBox height={144}>
			<StyledBox height={72} iconSize={72}>
				<ErrorIcon spacing="spacious" color={token('color.icon', N500)} label="" />
			</StyledBox>
			<StyledText>{formatMessage(messages.errorMessage)}</StyledText>
			{onRetry && (
				<Button
					onClick={onRetry}
					// TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
					// https://product-fabric.atlassian.net/browse/DSP-19035
					appearance="link"
				>
					{formatMessage(messages.retryMessage)}
				</Button>
			)}
		</StyledBox>
	);
};
